import { parsePhoneNumber } from 'libphonenumber-js';

export const ConvertPriceToString = (value, currency) => {
    const tmpCurrency = currency ?? 'PLN'
    const numericValue = Number(value) || 0

    let priceString = numericValue.toLocaleString('pl-PL', {
        style: 'currency',
        currency: tmpCurrency,
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
    if (currency === null) {
        priceString = priceString.replace('zł', ``)
    } else if (tmpCurrency === 'PLN') {
        priceString = priceString.replace(/\s*zł/, ` zł`)
    }
    return priceString;
}

export const CapitalizeFirstLowercaseRest = str => {
    let result = str
    try {
        result = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    } catch (error) {
        result = ''
    }
    return result
}

export function capitalizeFirstLetter(value) {
    return value.length ? value.charAt(0).toUpperCase() + value.slice(1) : "";
}

/**
 * DK: Funkcja formatująca numer telefonu do formatu międzynarodowego.
 * @param {string} value - Numer telefonu do sformatowania.
 * @returns {string} - Sformatowany numer telefonu w formacie międzynarodowym
 */
export function formatPhoneNumber(value) {
    if (!value) {
        return ''
    }
    const digits = value.replace(/\D/g, '')
    if (!digits) {
        return value
    }
    try {
        const phone = parsePhoneNumber('+' + digits)
        if (phone && phone.isValid()) {
            return phone.formatInternational()
        }
    } catch { }
    return '+' + digits
}